export const i18nCasePage = {
  analytics: {
    cases: 'Cases',
    cases_by_stage: 'Cases by stage',
    actions: 'Actions',
    pieChartSelect: {
      actions: {
        type_case_action: 'Actions by type',
        status: 'Action status',
      },
      cases: {
        discipline: 'Discipline',
        detection_method: 'Detection method',
        dimension: 'Dimension',
      },
    },
  },
  goToStageBanner: {
    message: 'Do you want to go to {{stage}} stage?',
    not_permitted: 'To go to {{stage}} stage, all the Actions must be executed.',
  },
  goToStage: {
    title: 'Do you want to leave {{currentStage}} and go to {{stage}} stage?',
    message:
      'To create a new action, you have to leave {{currentStage}} stage and go to {{stage}}.',
    no: 'No, stay in  {{currentStage}}',
    yes: 'Yes, go to {{stage}}',
  },
  ableToOperate: {
    tag: {
      active: 'Able to operate',
      inactive: 'Unable to operate',
    },
    modal: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      label: 'Asset can operate?',
      description:
        'If the asset is set as “Cannot operate”, an alarm will be triggered when it is turned on. You can also change the operational status on the asset page.',
      title: 'Asset operational Status',
    },
    options: {
      yes: 'Able to operate',
      no: 'Unable to operate',
    },
  },
  externalReference: {
    title: 'External references',
    tooltip: {
      plural: '{{value}} actions ',
      singular: '{{value}} action ',
    },
    not_found: 'Not found',
    'open-critical': 'Open critical',
    'open-non-critical': 'Open non critical',
    closed: 'Closed',
  },
  related: {
    table: {
      title: 'Add asset related alarm',
    },
    addEdit: 'Add/Edit',
  },
  actions_table: {
    creation_date: 'Creation Date',
    name: 'Action Name',
    case_name: 'Case Name',
    type_case_action: 'Type',
    details: 'Details',
    external_reference_type: 'External Ref.',
    external_reference: 'Code',
    owner_mail: 'Owner',
    status: 'Status',
    due_date: 'Due Date',
  },
  table: {
    agreg: '#',
    alarm_datetime_start: 'Start',
    asset: 'Asset',
    is_assigned_to_case: '',
    classification: 'Classific.',
    delete: '',
    description: 'Name',
    id: 'ID',
    link: '',
    name: 'Title',
    none: 'None',
    notif: '',
    records: 'Records',
    severity: 'Sever.',
    status: 'Stage',
    new_alarms: 'New',
    is_automatic: 'Auto Ack.',
    is_automatic_tooltip:
      'New alarms of the same model will be automatically acknowledged as useful and attached to this case while it is open.',
    is_automatic_blocked_tooltip:
      'This model is already set to “auto acknowledge” in another Case, so you can´t enable it here.',
  },
  buttons: {
    edit: 'Edit / Open full',
    evidences: 'Evidences ({{quantity}})',
    records: 'Records ({{quantity}})',
    relatedEvents: 'Related Events ({{quantity}})',
    newAction: 'New Action',
    newCase: 'New Case',
    casesPage: 'Cases page',
    back: 'Go back',
    expandCase: 'Expand Case',
  },
  filters: {
    allCategories: 'All Asset Categories',
    allOwners: 'All Owners',
    search: 'Search',
  },
  title: {
    cases: 'Cases',
    diagnosis: 'Diagnosis',
    actions: 'Actions ({{quantity}})',
    diagnosisValidation: 'Diagnosis Validation',
    feedback: 'Feedback',
  },
  status: {
    title: 'Stage',
    actions: 'Actions',
    canceled: 'Canceled',
    closed: 'Closed',
    diagnosis: 'Diagnosis',
    feedback: 'Feedback',
    on_hold: 'On Hold',
    none: 'None',
  },
  inputs: {
    description: 'Description',
    dimension: 'Dimension',
    severity: 'Severity',
    anomaly_start: 'Anomaly start',
    anomaly_end: 'Anomaly end',
    diagnosis: 'Diagnosis',
    team_a_review: 'Team A review',
    team_b_review: 'Team B review',
    asset: 'Asset',
    is_able_to_operate: 'Able to operate',
    detection_method: 'Detection method',
    discipline: 'Discipline',
    // Action
    type: 'Type',
    maintenanceNotification: 'Maintenance notification',
    status: 'Status',
    creationDate: 'Creation date',
    dueDateLabel: 'Due date',
    executionDateLabel: 'Execution Date',
    dueDateTooltip: 'When the due date is exceeded, the action status will change to Overdue',
    executionDateTooltip:
      'After saving the execution date, the action status will change to Executed',
    executionFeedback: 'Execution feedback',
    details: 'Details',
    equipment_class: 'Asset class',
    subunit: 'Subunit',
    failure_mode: 'Failure mode',
    failure_mechanism: 'Failure mechanism',
    total_estimated_cost: 'Total estimated (USD)',
    maintainable_item: 'Maintainable item',
    maintenance_scope: 'Maintanance scope',
  },
  placeholders: {
    caseTitle: 'Enter Case title here',
    actionTitle: 'Enter title here',
    awaitingDiagnoseClosure: 'Awaiting diagnose closure',
    diagnosis: 'Enter diagnosis details',
    selectAnOption: 'Select an option',
    selectUser: 'Select user',
    selectAsset: 'Select an asset',
    comments: 'Comments',
    owner: 'You',
    availableWithStatus: 'Available when you enter the execution date.',
    enterCode: 'Enter code',
    enterDetails: 'Enter details',
    enterNotificationNumber: 'Enter notification number',
    pickDate: 'Pick a date',
    select: 'Select',
    typeText: 'Enter any feedback you have about the execution of the action.',
    savings_description: 'A short summary about the saving event',
    enter_value: 'Enter value',
  },
  tooltips: {
    newActionNotAllowed: "New actions can only be added in the 'Actions' status.",
    owner: 'Owner: You',
    no_changes: 'No changes to save for now',
  },
  severity: {
    very_high: 'Very high',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    minor: 'Minor',
  },
  dimension: {
    dynamic_condition: 'Dynamic condition',
    auxiliary_system: 'Auxiliary system',
    process_condition: 'Process condition',
    oil_analysis: 'Oil analysis',
  },
  discipline: {
    rotative: 'Rotative',
    electrical: 'Electrical',
    instrumentation: 'Instrumentation',
    process: 'Process',
    automation: 'Automation',
    others: 'Others',
    EMPTY: 'Empty',
  },
  conclusion: {
    label: 'Conclusion about the anomaly',
    no_issue_found: 'No issue found',
    solved_completely: 'Solved completely',
    solved_partially: 'Solved partially',
    not_solved: 'Not solved',
  },
  team_review: {
    rejected: 'Rejected',
    accepted: 'Accepted',
  },
  actions: {
    status: {
      on_track: 'On track',
      delayed: 'Overdue',
      executed: 'Executed',
      none: 'None',
    },
    type_case_action: {
      maintenance: 'Maintenance',
      operations: 'Operations',
    },
  },
  created: 'Created',
  last_edition_by: 'Last edition: {{updatedAt}} | @{{username}}',
  mandatory_fields: '* Mandatory fields to next stage',
  main_tabs: {
    OPEN: 'Open',
    CLOSED: 'Closed',
    ALL: 'All',
  },
  table_tabs: {
    cases: 'Cases',
    actions: 'Actions',
  },

  tabs: {
    evidences: 'Evidences and Docs ({{quantity}})',
    records: 'Records',
    relatedAlarms: 'Related Alarms ({{quantity}})',
    relatedCases: 'Related Cases ({{quantity}})',
  },
  status_count_panel: {
    empty_data: 'No data available to filter',
    severity: {
      title: 'Severity',
      4: 'Very High',
      3: 'High',
      2: 'Medium',
      1: 'Low',
    },
    status: {
      action_status: {
        title: 'Action status',
        on_track: 'On Track',
        delayed: 'Overdue',
        all_executed: 'All Executed',
        executed: 'Executed',
        none: 'None',
      },
      total: { title: 'Total', total: 'Cases' },
      status: {
        title: 'Status',
        OPEN: 'Open',
        CLOSED: 'Closed',
      },
    },
  },
  common: {
    actions: 'Actions',
    action_status: 'Actions st.',
    anomaly_start: 'Anomaly start',
    anomaly_end: 'Anomaly end',
    asset: 'Asset',
    cancel: 'Cancel',
    category: 'Category',
    created: 'Created',
    description: 'Description',
    diagnosis: 'Diagnosis',
    dimension: 'Dimension',
    discipline: 'Discipline',
    event_code: 'ID',
    external_reference: 'External reference',
    external_reference_code: 'Code',
    external_reference_summary: 'Ext. Ref.',
    name: 'Name',
    none: 'None',
    owner_mail: 'Owner',
    save: 'Save',
    severity: 'Severity',
    start_date: 'Created',
    status: 'Stage',
    updated_at: 'Last edited',
    alarms_30_days: 'Alarms 30d',
    closed_date: 'Closed',
    preview: 'Preview',
  },
  no_data: {
    list: 'There are no cases available for the filtered settings.',
    related_alarms: 'No related alarm was added',
    related_alarms_modal: 'This asset has no alarms in the selected period',
    empty_actions: 'No actions created so far.',
  },
  new: 'New',
  new_case: 'New Case',
  new_action: 'New Action',
  expand: 'Expand list',
  show_analytics: 'Show Analytics',
  expand_tutorial_title: 'Introducing Visual Insights',
  expand_tutorial_description:
    'Your case list now includes charts for quick insights. Use "Expand List" to switch back to the full list view.',
  expand_tutorial_button: 'Got it',
  deleted: 'Deleted',
  cancel: 'Cancel',
  confirm_delete: 'Yes, delete',
  continue_anyway: 'Continue anyway',
  messages: {
    create: {
      title: 'Success!',
      message: 'New Case created successfully!',
    },
    edit: {
      title: 'Success!',
      message: 'Changes applied successfully!',
    },
    delete: {
      title: 'Delete action and lose all its data?',
      message: 'This action has information that will be lost. Are you sure you want to continue?',
    },
    delete_asset: {
      title: 'Related alarms will be cleared if you change the asset.',
      message: 'Are you sure you want to continue?',
    },
    attach_exit_without_saving: {
      title: 'Quit attaching the alarm to an existing Case?',
      button: {
        primary: 'Yes, quit',
        secondary: 'No, go back',
      },
    },
    cancel: {
      title: 'Why are you canceling this case?',
      placeholder: 'Please enter a justification',
      button: {
        primary: 'Cancel this case',
        secondary: 'Go back',
      },
    },
    diagnosis_not_filled: {
      title: 'Please fill in all required fields',
      message:
        'Before going to Actions stage, you need to fill in the Title, Asset and Diagnosis fields.',
      button: {
        ok: 'OK',
      },
    },
    diagnosis_to_actions: {
      title: 'Finish Diagnosis and go to Actions?',
      message:
        'Diagnosis will be saved and the stage will change to Actions, so you can create actions.',
      button: {
        go_to_actions: 'Yes, go to Actions',
        cancel: 'Cancel',
      },
    },
  },
  records: {
    creation_date: 'Creation Date',
    name: 'Action Name',
    case_name: 'Case Name',
    type_case_action: 'Type',
    details: 'Details',
    external_reference: 'External reference type',
    code: 'External reference code',
    owner_mail: 'Owner',
    status: 'Status',
    due_date: 'Due Date',
    end_date: 'Execution Date',
    dimension: 'Dimension',
    severity: 'Severity',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    very_high: 'Very High',
    anomaly_start: 'Anomaly start',
    anomaly_end: 'Anomaly end',
    detection_method: 'Detection method',
    diagnosis: 'Diagnosis',
    discipline: 'Discipline',
    conclusion: 'Conclusion',
    feedback: 'Feedback',
    actions: 'Actions',
    feedback_comments: 'Feedback comments',
    feedback_conclusion: 'Feedback conclusion',
    title: 'Records',
    add_a_comment: 'Add a comment',
    view_records: 'View records',
    event_records: 'Event records',
    attachments: 'Attachments',
    comments: 'Comments',
    summary: {
      attachments: 'Attachments',
      comments: 'Comments',
      last_update: 'Last update: ',
    },
    category: {
      alarm_created: 'Alarm created',
      alarm_visualized: 'Alarm visualized',
      alarm_closed: 'Alarm closed',
      attached_file: 'Attached file',
      detached_file: 'Detached file',
      comment: 'Comment',
    },
  },
  evidences: {
    title: 'Evidences and Documents ({{quantity}})',
    new: 'New',
    attach: 'Attach',
    attached: 'Attached',
    no_data: 'No attachments for now',
    undo: 'Undo',
    drag_file_here: 'Drag and drop here',
    drop_file_here: 'Drop file here',
    search_in_device: 'Search in my device',
    upload_not_available: 'Upload not available in this context',
    upload_files_to_continue: 'Upload files to continue',
    save_attched_files: 'Save attached files',
    messages: {
      exit: {
        title: 'Attention!',
        message: 'If you leave without saving, these changes will be lost.',
      },
      repetead: {
        title: 'Sorry, there are attached files with the same name',
        message: 'Please rename the file before selecting it.',
      },
      mandatory: {
        title: 'Sorry, could not save status.',
        message: 'Please fill in all mandatory fields (with *) before changing status.',
      },
      tooltip: 'Allowed file formats: XLS, TXT, PDF, DOC, JPG and PNG with size up to 10 Mb',
      tooltipRevert: 'Undo deletion',
      upload_success: 'Files uploaded successfully',
      delete_success: 'File deleted successfully',
      delete_error: 'Error deleting file, please try again.',
      upload_failed: 'Error uploading files, please try again.',
      some_uploads_failed: 'Failed to upload {{count}} files',
    },
    buttons: {
      exit: 'Exit anyway',
      back: 'Go back',
      ok: 'Ok',
    },
  },
  savings: {
    title: 'Savings',
    has_savings: {
      no: 'No',
      yes: 'Yes',
    },
  },
  tooltip: {
    asset_title_mandatory: 'You must enter case title and asset to proceed.',
  },
  Cases: {
    item: 'Condition Deviation',
    openAsset: 'Open asset',
    newCd: 'New CD',
    openNewCD: 'Create new Condition Deviation',
    editCD: 'Edit Condition Deviation',
    asset: 'Asset',
    newAsset: 'Select an asset',
    asset_id: 'Asset ID',
    dimension: 'Dimension',
    category: 'Category',
    category_id: 'Category Id',
    detection_method: 'Detection Method',
    deviation_start: 'Deviation start',
    deviation_end: 'Deviation end',
    duration: 'Duration',
    diagnosis: 'Diagnosis',
    detailing: 'Detailing',
    recommended_action: 'Recommended actions',
    actionStatus: 'Action status',
    sap_note: 'Note',
    sapNoteTooltip: 'Note field is required with Action status “Action issued”',
    assetConditionEvaluation: 'Severity',
    condition_evaluation: 'Severity',
    assetStatus: 'Asset status',
    savings: 'Savings',
    savings_required: 'Savings',
    savingsNoteTooltip: 'Savings field is optional and can be filled anytime',
    description: 'Description',
    equipment_class: 'Asset class',
    subunit: 'Subunit',
    maintainable_item: 'Maintainable item',
    failureMode: 'Failure mode',
    failure_mechanism: 'Failure mechanism',
    maintenance_scope: 'Maintenance scope',
    noFillesAttached: 'No files attached',
    alarmsLinked: '{{alarmsCount}} Alarms linked',
    toThisCD: 'to this Condition Deviation',
    addViewAlarms: 'Add/view asset alarms',
    caseOwner: 'Owner:',
    attachFile: 'Attach file',
    is_out_of_service: 'Asset can operate?',
    outOfServiceOptions: {
      yes: 'Able to operate',
      no: 'Unable to operate',
    },
    options: {
      tooltip: {
        actions: 'Please complete all required fields on Diagnosis before switching the stage.',
        feedback: 'Actions must have status “Executed” or “Cancelled” (saved) to go to Feedback.',
        closed: 'Please complete all required fields on Feedback before switching to Closed.',
      },
      action_status: {
        INVESTIGATING: 'Investigating',
        ACTION_ISSUED: 'Action issued',
        CANCELED: 'Canceled',
        UNDER_EVALUATION: 'Under evaluation',
        COMPLETED: 'Completed',
      },
      dimensions: {
        AUXILIARY_SYSTEM: 'Auxiliary System',
        PROCESS_CONDITION: 'Process Condition',
        DYNAMIC_CONDITION: 'Dynamic Condition',
        OIL_ANALYSIS: 'Oil Analysis',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Low',
        ALARM_CONDITION: 'Medium',
        CRITICAL_CONDITION: 'Very High',
        POTENTIAL_PROBLEM: 'High',
        NOT_MONITORED: 'Not Monitored',
        NOT_OPERATED: 'Not Operated',
        modec: {
          NORMAL_CONDITION: 'Normal Condition',
          ALARM_CONDITION: 'Alarm Condition',
          CRITICAL_CONDITION: 'Critical Condition',
          POTENTIAL_PROBLEM: 'Potential Problem',
          NOT_MONITORED: 'Not Monitored',
          NOT_OPERATED: 'Not Operated',
        },
      },
    },
    confirmChangeAsset:
      'If you change the Asset, the linked alarms will be cleared. Continue anyway?',
    yesContinue: 'Yes, continue',
    save: 'Save',
    cancel: 'Cancel',
    placeholders: {
      assetName: 'Start typing to display options',
      dimension: 'Select dimension',
      selectAnOption: 'Select an option',
      select: 'Select',
      dayHour: 'Pick day and hour',
      diagnosis: 'Enter deviation diagnosis',
      detailing: 'Enter details',
      recommendedActions: 'Enter recomendations',
      sapCode: 'Enter note',
      description: 'A short summary about the saving event',
    },
    messages: {
      toBeRequired: 'This field is required',
      confirmTurnOffCannotOperate:
        'Are you sure you want to TURN OFF status CANNOT OPERATE for this equipment?',
      confirmTurnOnCannotOperate:
        'Are you sure you want to TURN ON status CANNOT OPERATE for this equipment?',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    modalTitles: { new: 'Open New Condition Deviation', edit: 'Condition Deviation' },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'High',
      CRITICAL_CONDITION: 'Very High',
      ALARM_CONDITION: 'Medium',
      NORMAL_CONDITION: 'Low',
    },
  },
  tableColumns: {
    severity: 'Severity',
    start_date: 'Created',
    name: 'Name',
    dimension: 'Dimension',
    discipline: 'Discipline',
    status: 'Stage',
    action_status: 'Actions st.',
    externalReference: 'Ext. ref.',
    updated_at: 'Last edition',
  },
  components: {
    casesByAssetTable: {
      name: 'Asset',
      bar: 'Cases',
      count: '#',
    },
    casesByOwnerTable: {
      owner_mail: 'Owner',
      cases: 'Cases',
      no_data: 'No data available',
      number: '#',
    },
  },
  error: {
    noOpenCases: 'There are no open cases at the moment.',
    noClosedCases: 'There are no closed cases in the selected period.',
    noCases: 'No Cases in the period and filters selected.',
  },
  assetCases: 'Asset Cases',
};
